import keys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as collectorsAPI from '@debbie/cortex/dist/api/collectors.js';
import { collectorsEntity } from '@debbie/cortex/dist/collectors/index.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import React from 'react';
import { useSelector } from 'react-redux';
import EmailServer from '../../EmailServer.js';
import { AddressInput, PhoneInput, SmallHeader } from '../../index.js';
import EntityUpdater from '../EntityUpdater.js';
import { InitiateDNSButton } from '../InitiateDNS.js';
const Master = (props) => {
    const { collector, lang } = props;
    const exclusiveContent = useSelector(selectExclusiveContent);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const updateCollector = useMutation((patch) => collectorsAPI.update(collector.collectorId, patch), {
        onSuccess: () => {
            q.invalidate(keys.write.modify(collectorsEntity, collector.collectorId));
        },
        onError: (err) => {
            console.log(err);
            alert(err);
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, lang.collectors.masterData),
        React.createElement(EntityUpdater, { key: "name", entity: "name", collector: collector }),
        React.createElement(EntityUpdater, { key: "nickname", entity: "nickname", collector: collector }),
        React.createElement(EntityUpdater, { key: "title", entity: "title", collector: collector }),
        React.createElement(EntityUpdater, { key: "centralRegisterId", entity: "centralRegisterId", collector: collector }),
        React.createElement(SmallHeader, null, lang.collectors.addressPlaceholder),
        React.createElement(AddressInput, { placeholder: lang.collectors.addressPlaceholder, address: collector.address, onChange: (address) => updateCollector.mutate({ address }) }),
        React.createElement(SmallHeader, null, lang.collectors.phonePlaceholder),
        React.createElement(PhoneInput, { placeholder: lang.collectors.phonePlaceholder, phone: collector.phone, onChange: (phone) => updateCollector.mutate({ phone }) }),
        React.createElement(EntityUpdater, { key: "email", entity: "email", collector: collector, disabled: !(me && exclusiveContent?.includes(me.id)) }),
        React.createElement(EntityUpdater, { key: "replyTo", entity: "replyTo", collector: collector }),
        React.createElement(InitiateDNSButton, { collectorId: collector.collectorId }),
        me && exclusiveContent?.includes(me.id) && (React.createElement(EmailServer, { emailServerId: collector.emailServerId }))));
};
export default Master;
//# sourceMappingURL=Master.js.map